//功能权限 控制
// <el-button v-permission="'user-add'">添加</el-button> 或 <el-button v-permission="['user-add']">添加</el-button>
// <el-button v-permission="'user-add,user-sub-add'">添加</el-button>
// <el-button v-permission="['user-add','user-sub-add']">添加</el-button>

"use strict";

import Vue from 'vue'
import store from '@/store'

const _permission= {
    inserted(el, binding, vnode) {
        const permissions = store.state.user&&store.state.user.permissions
        // 字符串模式
        var value=binding.value;
        if(typeof value =='string'){
            value=value.split(",")
        }

        if (value && value instanceof Array && value.length > 0) {
            const hasPermission = permissions.some(val => {
                return value.includes(val)
            })
            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`need permission! Like v-permission="['user-add']"`)
        }
    }
}


const plugin = {
    install() {
        Vue.directive('permission', _permission)
    }
}

Vue.use(plugin)
export default _permission